import React, { useEffect, useState } from 'react';
import { isEmpty } from "lodash";
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { InputWithError } from 'common/InputWithError';
import { SpinnerButton } from 'common/SpinnerButton';

export const EditSettingsModal = ({ isOpen, toggle, handleEditSettings, item }) => {
    const [settingsValue, setSettingsValue] = useState('');
    const [settingsChoices, setSettingsChoices] = useState([]);

    const handleSubmit = async () => {
        await handleEditSettings(item.id, settingsValue);
        toggle();
    };

    useEffect(() => {
        if (item) {
            setSettingsValue(item.value);
            !isEmpty(item?.choices) && setSettingsChoices(Object.entries(item.choices));
        }
    }, [isOpen]);

    return (
        <div>
            <Modal isOpen={isOpen} className="modal-md">
                <ModalHeader toggle={toggle}>Edit Settings</ModalHeader>
                <ModalBody style={{ paddingBottom: '2rem' }}>
                    {!isEmpty(item?.choices) ? (
                        <div>
                            <Input
                                type="select"
                                name="selectSettings"
                                value={settingsValue}
                                onChange={(e) => setSettingsValue(e.target.value)}>
                                {settingsChoices.map(choice => (
                                    <option value={choice[0]} key={choice[0]}
                                            defaultChecked={choice[0] === settingsValue}>{choice[1]}</option>
                                ))}
                            </Input>
                        </div>
                    ) : (
                        <div>
                            <Label className="mr-2 mb-2">
                                Enter <b>{item.name}</b> value
                            </Label>
                            <div>
                                <InputWithError
                                    name="settingsValue"
                                    value={settingsValue}
                                    type="text"
                                    onChange={setSettingsValue}
                                    errorObj={null}
                                    marginBottomClass="mb-3"
                                />
                            </div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                    <SpinnerButton
                        type='modal'
                        color='primary'
                        onClick={handleSubmit}
                        title='Update'
                    />
                </ModalFooter>
            </Modal>
        </div>
    );
};
